<ng-container *transloco="let t">
  <div class="admin-layout OTP">
    <div class="app-login-body">
      <img class="login-screen-main-img" src="../../assets/app-assets/images/general/login-screen-main-img.svg" alt="">
            <img class="login-screen-pattren-img" src="../../assets/app-assets/images/general/login-pattern.svg" alt="">
            
            <div class="login-header d-flex justify-content-between">
                <div>
                    <div class="logo">
                        <img src="../../assets/app-assets/images/logo/logo-yellow.svg" alt="">
                    </div>
                    <p class="text clr-white fs-12">Customizable connectivity solutions that<br>matter to your business.</p>
                </div>
                <div class="login-page-lang">
                    <app-language-changer />
                </div>
            </div>
      <div class="row">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="card login-form">
            <div class="card-body">
              <div class="text-center mb-4">
                <p class="title clr-primary xl font-m ">{{ t("otpHeader") }}</p>
                <p class="text">{{ t("otpSubHeader") }}</p>
              </div>
              <form [formGroup]="otpForm" (ngSubmit)="submit()" class="form flex flex-column" novalidate>
                <div class="form-container">
                  <div class="field">
                    <input
                      formControlName="otp"
                      type="number"
                      autocomplete="off"
                      pInputText
                      [placeholder]="t('otpPlaceHolder')"
                    />
                  </div>
                </div>
                <div class="button-container">
                  <button
                    type="submit"
                    class="app-button btn-secondary w-100"
                    label="Login"
                    [disabled]="disableOtpSubmitButton || !otpForm.valid"
                  >
                    submit
                    <span style="margin-left: 65%; position: absolute"
                      ><i *ngIf="disableOtpSubmitButton" style="float: right" class="pi pi-spin pi-spinner"></i
                    ></span>
                  </button>
                </div>
                <div class="text-end mt-3">
                  <button [disabled]="timerActive || disableResendBtn" class="app-button btn-secondary" (click)="resendOtp()"
                    >{{ t("resendOTP") }} <span *ngIf="timerActive"> ({{ timerInSeconds }}) </span></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="login-footer">
        <p class="text text-white fs-12">{{ t("SMEInABox") }}</p>
        <p class="text text-white fs-12">|</p>
        <p class="text text-white fs-12">{{latestYear}} {{ t("loginFooterText") }}.</p>
      </div>
    </div>
  </div>
</ng-container>
